import { WidgetDefinition } from '../models/WidgetDefinition';

export const TableByGroupDefinition: WidgetDefinition = {
    baseType: 'TableByGroup',
    group: 'Charts',
    hasImage: true,
    highlights: ['Aggregated values of the same identifiers from multiple groups', 'You can select the groups one by one or by type'],
    icon: 'fa-table',
    sortingOrder: 1200,
    title: 'Table by group type(s)',
    type: 'TableByGroup'
};